import { makeStyles, shorthands } from "@fluentui/react-components";

export const useFeedManagerStyles = makeStyles({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("8px"),
    paddingBottom: "95px",
  },

  dialogButtons: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "flex-end",
    ...shorthands.gap("8px"),
    width: "100%",
    ...shorthands.padding("24px"),
    position: "fixed",
    bottom: "0px",
    right: "0px",
    backgroundColor: "white",
  },
});
